import React from "react";
import ReportList from "./ReportList";

const ReportsSection: React.FC = () => (
  <section id="reports" className="w-full flex flex-col items-center py-16 sm:py-24 px-4 sm:px-6 scroll-mt-20 bg-[#fafaf7]">
    <ReportList />
  </section>
);

export default ReportsSection;
